module.exports = __webpack_public_path__ + "img/english-kids-es.5310967b.png";